import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import Navbar from "../inc/Navbar";
import listyourproperty from "../images/LIST YOUR PROPERTY.jpg";

function ListYourProperty() {
  const [formData, setFormData] = useState({
    ownerName: "",
    mobile: "",
    email: "",
    propertyType: "",
    location: "",
    district: "",
    landArea: "",
    price: "",
    facing: "",
    roadWidth: "",
    documents: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "properties"), {
        ...formData,

        // FIREBASE TIMESTAMP
        createdAt: serverTimestamp(),

        // NORMAL DATE & TIME
        submitDate: new Date().toLocaleDateString("en-IN"),
        submitTime: new Date().toLocaleTimeString("en-IN"),
        fullDate: new Date().toLocaleString("en-IN"),
      });

      alert("Property Submitted Successfully!");

      setFormData({
        ownerName: "",
        mobile: "",
        email: "",
        propertyType: "",
        location: "",
        district: "",
        landArea: "",
        price: "",
        facing: "",
        roadWidth: "",
        documents: "",
        message: "",
      });

    } catch (error) {
      console.log(error);
      alert("Something went wrong!");
    }
  };

  return (
    <>
      <Navbar />

      <br />
      <br />
    
      <section className="property-form-section">
        <div className="property-form-box">

          <h2 style={{ color: "#D5A843" }}>List Your Property</h2>

          <p>
            আপনার জমি / প্রপার্টি বিক্রয়ের জন্য সঠিক তথ্য দিয়ে লিস্ট করুন
          </p>

          <form onSubmit={handleSubmit}>

            <div className="form-grid">

              <input
                type="text"
                name="ownerName"
                placeholder="Owner Name"
                value={formData.ownerName}
                onChange={handleChange}
                required
              />

              <input
                type="tel"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
              />

              <select
                name="propertyType"
                value={formData.propertyType}
                onChange={handleChange}
                required
              >
                <option value="">Select Property Type</option>
                <option value="Land">Land</option>
                <option value="Plot">Plot</option>
                <option value="House">House</option>
                <option value="Flat">Flat</option>
                <option value="Commercial">Commercial</option>
              </select>

              <input
                type="text"
                name="location"
                placeholder="Property Location"
                value={formData.location}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="district"
                placeholder="District"
                value={formData.district}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="landArea"
                placeholder="Land / Plot Area"
                value={formData.landArea}
                onChange={handleChange}
              />

              <input
                type="text"
                name="price"
                placeholder="Expected Price"
                value={formData.price}
                onChange={handleChange}
              />

              <input
                type="text"
                name="facing"
                placeholder="Facing e.g. East / South"
                value={formData.facing}
                onChange={handleChange}
              />

              <input
                type="text"
                name="roadWidth"
                placeholder="Road Width"
                value={formData.roadWidth}
                onChange={handleChange}
              />

              <select
                name="documents"
                value={formData.documents}
                onChange={handleChange}
              >
                <option value="">Documents Status</option>

                <option value="Clear Documents">
                  Clear Documents
                </option>

                <option value="Mutation Done">
                  Mutation Done
                </option>

                <option value="Porcha Available">
                  Porcha Available
                </option>

                <option value="Conversion Done">
                  Conversion Done
                </option>

                <option value="Under Process">
                  Under Process
                </option>
              </select>

            </div>

            <textarea
              name="message"
              placeholder="Additional Property Details"
              value={formData.message}
              onChange={handleChange}
              rows="5"
            ></textarea>

            <button type="submit" className="submit-btn">
              Submit Property
            </button>

          </form>
        </div>

      </section>
      <br/>
        <div className="album py-0">
        <div className="container">
          <div className="radius">
            <img src={listyourproperty} className="card-img-top" alt="listyourproperty" />
          </div>
        </div>
      </div>
      <br/>
    </>
  );
}

export default ListYourProperty;